import { CVData, CVDesignConfig } from '../types';

export const generateHTMLFromCV = (data: CVData, design: CVDesignConfig): string => {
    let html = '';

    // Styles
    const h1Style = `font-family: ${design.fontFamily}; font-size: 32px; font-weight: bold; color: ${design.primaryColor}; margin-bottom: 8px;`;
    const h2Style = `font-family: ${design.fontFamily}; font-size: ${design.fontSizeHeading}px; font-weight: bold; color: ${design.primaryColor}; border-bottom: 2px solid ${design.primaryColor}; margin-top: 24px; margin-bottom: 12px; padding-bottom: 4px;`;
    const pStyle = `font-family: ${design.fontFamily}; font-size: ${design.fontSizeBody}px; color: ${design.textColor}; line-height: 1.6; margin-bottom: 8px;`;
    const boldStyle = `font-weight: bold;`;
    const italicStyle = `font-style: italic;`;

    // Header
    html += `<h1 style="${h1Style}">${data.personalInfo.name || 'Naam'}</h1>`;
    html += `<p style="${pStyle}; font-size: 18px; margin-bottom: 16px;">${data.title || 'Functie'}</p>`;

    // Contact Info (Inline)
    const contacts = [];
    if (data.personalInfo.email) contacts.push(data.personalInfo.email);
    if (data.personalInfo.phone) contacts.push(data.personalInfo.phone);
    if (contacts.length > 0) {
        html += `<p style="${pStyle}; opacity: 0.8; font-size: 14px;">${contacts.join(' • ')}</p>`;
    }

    html += `<hr style="border: 0; border-top: 1px solid #ddd; margin: 24px 0;" />`;

    // Summary
    if (data.summary) {
        html += `<h2 style="${h2Style}">Profielschets</h2>`;
        html += `<p style="${pStyle}">${data.summary.replace(/\n/g, '<br/>')}</p>`;
    }

    // Work History
    if (data.workHistory && data.workHistory.length > 0) {
        html += `<h2 style="${h2Style}">Werkervaring</h2>`;
        data.workHistory.forEach(item => {
            html += `<div style="margin-bottom: 16px;">`;
            html += `<div style="display: flex; justify-content: space-between; margin-bottom: 4px;">`;
            html += `<span style="${pStyle}; ${boldStyle}">${item.role}</span>`;
            html += `<span style="${pStyle}; opacity: 0.7;">${item.period}</span>`;
            html += `</div>`;
            html += `<div style="${pStyle}; ${italicStyle}; margin-bottom: 4px;">${item.company}</div>`;
            html += `<p style="${pStyle}">${item.description.replace(/\n/g, '<br/>')}</p>`;
            html += `</div>`;
        });
    }

    // Education
    if (data.education && data.education.length > 0) {
        html += `<h2 style="${h2Style}">Opleiding</h2>`;
        data.education.forEach(item => {
            html += `<div style="margin-bottom: 12px;">`;
            html += `<div style="display: flex; justify-content: space-between;">`;
            html += `<span style="${pStyle}; ${boldStyle}">${item.degree}</span>`;
            html += `<span style="${pStyle}; opacity: 0.7;">${item.year}</span>`;
            html += `</div>`;
            html += `<div style="${pStyle}">${item.school}</div>`;
            html += `</div>`;
        });
    }

    // Skills
    if (data.skills && data.skills.length > 0) {
        html += `<h2 style="${h2Style}">Vaardigheden</h2>`;
        html += `<p style="${pStyle}">${data.skills.join(', ')}</p>`;
    }

    return html;
};
